import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/common/close.png'
import _imports_1 from '@/assets/images/common/vip.png'


const _hoisted_1 = { class: "loginStatus-box-outer" }
const _hoisted_2 = {
  key: 0,
  class: "login"
}
const _hoisted_3 = {
  key: 1,
  class: "avatar-box"
}
const _hoisted_4 = { class: "menu_top" }
const _hoisted_5 = { class: "vipBox" }
const _hoisted_6 = { class: "menu_nickname" }
const _hoisted_7 = {
  key: 0,
  class: "vip",
  src: _imports_1
}
const _hoisted_8 = { class: "menu_btm" }
const _hoisted_9 = { class: "menu_bar" }
const _hoisted_10 = { class: "menu_loginOut" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_sideBar = _resolveComponent("sideBar")!
  const _component_vanButton = _resolveComponent("vanButton")!
  const _component_vanOverlay = _resolveComponent("vanOverlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.user.avatar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              key: "login",
              to: "/login",
              class: "text"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" 登录 ", -1)
              ]))]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createTextVNode(" | ", -1)),
            _createVNode(_component_router_link, {
              key: "register",
              to: "/register",
              class: "text register"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" 注册 ", -1)
              ]))]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_avatar, {
              class: "e-avatar",
              src: _ctx.user.avatar,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = true))
            }, null, 8, ["src"])
          ]))
    ]),
    _createVNode(_component_vanOverlay, {
      show: _ctx.show,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.show = false)),
      "z-index": 1111
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "menu_wrapper",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "closeBtn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false))
            }),
            _createVNode(_component_el_avatar, {
              class: "e-avatar",
              src: _ctx.user.avatar
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.nickname), 1),
              (_ctx.user.is_vip == '1')
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_sideBar)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_vanButton, {
                type: "default",
                round: "",
                block: "",
                onClick: _ctx.loginOut
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("退出登录", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}